import React from 'react';
import { ScienceAssociation2026 } from '../views';

const BlogNewsroomPage = () => {
return <ScienceAssociation2026/>
};

export default BlogNewsroomPage;